module.exports = __webpack_public_path__ + "img/literature.18c6f8c3.png";